"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _HelperText = _interopRequireWildcard(require("./HelperText"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CharacterCount = props => {
  const {
    prefix = '',
    targetID,
    limit = 0,
    characterCount,
    onStateChange,
    ...otherProps
  } = props;
  const [count, setCount] = (0, _react.useState)(0);
  function handleChange(event) {
    if (event.target) {
      setCount((event.target.value || event.target.textContent || '').length);
    }
  }
  (0, _react.useEffect)(() => {
    if (characterCount || characterCount === 0) {
      setCount(characterCount);
      return;
    }
    if (!targetID) return;
    const target = document.getElementById(targetID);
    if (target) {
      target.addEventListener('input', handleChange, {
        passive: true
      });
      target.addEventListener('change', handleChange, {
        passive: true
      });
      if (target.value) setCount(String(target.value).length);
    }
    return () => {
      if (target) {
        target.removeEventListener('input', handleChange);
        target.removeEventListener('change', handleChange);
      }
    };
  }, [targetID, characterCount]);
  const stateCache = _react.default.useRef(false);
  (0, _react.useEffect)(() => {
    const nextState = count <= limit;
    if (onStateChange && stateCache.current !== nextState) onStateChange(nextState);
    stateCache.current = nextState;
  }, [count]);
  return _react.default.createElement(_HelperText.default, _extends({
    prefix: prefix
  }, otherProps, {
    className: (0, _classnames.default)(`${prefix}helper-text--character-count`, otherProps.className),
    textOnly: true,
    shouldValidate: count > limit,
    valid: false
  }), `${count}/${limit}`);
};
CharacterCount.displayName = 'CharacterCount';
var _default = CharacterCount;
exports.default = _default;